import { T } from 'consts/translationKeys'
import { VISUAL_MEDIA_TYPE_OVERLAY } from 'containers/SubSidebar/data'
import { dispatch } from 'store'
import { editorThunks } from 'store/features/editor/thunks'
import { translate } from 'utils/translations'
import ActionButton from '../ActionButton'
import { useSelector } from 'react-redux'
import { selectActiveMedia } from 'store/selectors'
import EditIcon from 'assets/svgr-icons/Edit.svg'
import { useCallback } from 'react'

export const EditButton = () => {
  const activeMediaItem = useSelector(selectActiveMedia)

  const handleMediaItemEdit = useCallback(() => {
    if (!activeMediaItem) {
      return
    }
    if (activeMediaItem.id && activeMediaItem.type) {
      dispatch(
        editorThunks.selectSingleTimelineItem({
          id: activeMediaItem.id,
          type: activeMediaItem.type
        })
      )

      const overlayType = VISUAL_MEDIA_TYPE_OVERLAY[activeMediaItem.type]
      if (overlayType) {
        dispatch(editorThunks.setAsideOverlayContent(overlayType))
      }
    }
  }, [activeMediaItem])

  const handleEdit = () => {
    dispatch(editorThunks.setIsMobileSubSidebarOpen(true))
    // additional handling for media item edit
    handleMediaItemEdit()
  }

  return (
    <ActionButton
      icon={<EditIcon />}
      tooltipText={translate(T.EDIT_LABEL)}
      onClick={handleEdit}
    />
  )
}
